/**
 * The directory's creation date, rendered for a table cell.
 *
 * The value is AD's `whenCreated`, normalised to ISO-8601 by the backend.
 * It is NOT the age of our cache row, and it is legitimately absent on a
 * domain controller running an agent older than the one that started asking
 * for the attribute — so "—" here means "this DC did not tell us", not
 * "created at the epoch". Rendering an absent date as 1970 is the failure to
 * avoid; it reads as real data.
 */
export function formatCreated(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** The same value with the time, for tooltips and detail panels. */
export function formatCreatedFull(value) {
  if (!value) return 'not reported by this domain controller';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'not reported by this domain controller';
  return d.toLocaleString();
}

export default formatCreated;
